import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { TaskServiceInterface } from "./definitions/task-service-interface";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import createDraftMutation from "./mutations/create-draft";
import { FetchResult } from '@apollo/client/core';

interface CreateDraftResponse {
  task: {
    createDraft: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class CreateDraftService {
  constructor(private apollo: Apollo) {}

  createDraft(draft): Observable<FetchResult<CreateDraftResponse>> {
    return this.apollo.mutate<CreateDraftResponse>({
      mutation: createDraftMutation,
      variables: draft,
    });
  }
}
